<template>
  <v-container id="nlpanalyzerContainer" fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex d-flex xs12 order-xs5>
        <v-layout column>
          <v-flex d-flex>
            <v-card color="blue-grey">
              <v-card-text>xxxx</v-card-text>
              <v-switch
                v-model="noun"
                :label="$t('nlp.noun')"
                color="blue"
              ></v-switch>
              <v-switch
                v-model="verb"
                :label="$t('nlp.verb')"
                color="blue"
              ></v-switch>
            </v-card>
          </v-flex>
          <v-flex d-flex>
            <v-card color="brown" dark>
              <v-card-text>zzzz</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex xs6>
        <v-layout row wrap>
          <v-flex d-flex>
            <v-card color="#132339">
              <v-layout row wrap>
                <v-flex xs3>
                  <v-subheader v-text="$t('nlp.lang')"></v-subheader>
                </v-flex>
                <v-flex xs2>
                  <v-select
                    :items="lang"
                    v-model="selectedLang"
                    :label="$t('nlp.select')"
                    single-line
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex d-flex xs6 child-flex>
        <v-card color="#132339">
          <v-layout row wrap>
            <v-flex xs3>
              <v-subheader v-text="$t('nlp.input')"></v-subheader>
            </v-flex>
            <v-flex xs6>
              <v-file-input
                v-model="inFile"
                label="File Input"
                dense
              ></v-file-input>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn right @click="importTxt">Read File</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "NLPAnalyzer",
  data() {
    return {
      noun: true,
      verb: true,
      lang: [],
      selectedLang: null,
      inFile: null
    };
  },
  created() {
    this.get_lang();
  },
  methods: {
    get_lang() {
      this.$http
        .get("/api/llist")
        .then(response => {
          this.lang = [];
          if (response.status === 200) {
            response.data.llist.forEach(l => this.lang.push(l));
          }
        })
        .catch(error => console.log(error));
    },
    importTxt() {
      console.log("running import ....");
    }
  }
};
</script>
